import { Autocomplete, SxProps, TextField, Theme } from '@mui/material';
import { Controller } from 'react-hook-form';
import { FC } from 'react';

interface Props {
    name: string;
    label: string;
    options: any[];
    getOptionLabel?: (option: any) => string;
    isOptionEqualToValue?: (option: any, value: any) => boolean;
    allValuesAllowed?: boolean;
    defaultValue: any;
    sx?: SxProps<Theme>;
}
export const AutocompleteComponent: FC<Props> = ({
    name,
    label,
    options,
    getOptionLabel,
    isOptionEqualToValue,
    allValuesAllowed,
    defaultValue,
    ...props
}) => {
    return (
        <Controller<any>
            name={name}
            defaultValue={defaultValue}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <Autocomplete
                    id={`${name}-field`}
                    autoComplete={allValuesAllowed}
                    freeSolo={allValuesAllowed}
                    onChange={(e, data) => onChange(data)}
                    onInputChange={allValuesAllowed ? (e, data) => onChange(data) : undefined}
                    value={value}
                    options={options}
                    getOptionLabel={getOptionLabel}
                    isOptionEqualToValue={isOptionEqualToValue}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            slotProps={{ inputLabel: { ...params.InputLabelProps, shrink: true } }}
                            error={!!error}
                            helperText={error ? error.message : null}
                        />
                    )}
                    {...props}
                />
            )}
        />
    );
};
